import React, { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../store/session";
import LogoutButton from "../../auth/LogoutButton";
import LogoBrand from "../LogoBrand";
import LangToggle from "../LangToggle";

import no_photo from "../../../assets/no_photo.svg";

import { Modal } from "../../../context/Modal";
import UserProfile from "../../Profile/UserProfile";

const UserBar = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.session.user);
	const hasUnread = useSelector((state) => state.hasUnread);
	const whitelabelAgent = useSelector((state) => state.whitelabel?.agent);
	const [showMenu, setShowMenu] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showMobileMenu, setShowMobileMenu] = useState(false);

	const image = user.photo || no_photo;

	const dropdownRef = useRef();

	const openMenu = (e) => {
		e.preventDefault();
		setTimeout(() => {
			setShowMenu(true);
		}, 1);
		document.addEventListener("click", closeMenu);
	};

	const closeMenu = (e) => {
		e.preventDefault();
		if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
			setShowMenu(false);
			document.removeEventListener("click", closeMenu);
		}
	};

	const onLogout = async () => {
		setShowMobileMenu(false);
		setShowMenu(false);
		await dispatch(logout());
	};

	return (
		<>
			<nav className="nav">
				<div className="nav-lf">
					{whitelabelAgent ? (
						<div className="flex items-center gap-2 nav-desktop-only">
							{whitelabelAgent.photo && (
								<img
									src={whitelabelAgent.photo}
									alt={whitelabelAgent.username}
									style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover' }}
								/>
							)}
							<span className="btn-font-lt">
							{whitelabelAgent.username}{whitelabelAgent.office ? `, ${whitelabelAgent.office}` : ''}
						</span>
						</div>
					) : (
						<NavLink to="/agents" className="btn-font-lt nav-desktop-only">
							Agent Finder
						</NavLink>
					)}
					<button
						type="button"
						className="nav-hamburger"
						onClick={() => setShowMobileMenu((v) => !v)}
						aria-label="Menu"
					>
						{showMobileMenu ? (
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round">
								<line x1="3" y1="3" x2="15" y2="15" />
								<line x1="15" y1="3" x2="3" y2="15" />
							</svg>
						) : (
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round">
								<line x1="2" y1="5" x2="16" y2="5" />
								<line x1="2" y1="9" x2="16" y2="9" />
								<line x1="2" y1="13" x2="16" y2="13" />
							</svg>
						)}
					</button>
				</div>
				<NavLink to="/" exact={true} onClick={() => setShowMobileMenu(false)}>
					<LogoBrand agentName={whitelabelAgent?.username || null} agentPhoto={whitelabelAgent?.photo || null} />
				</NavLink>
				<div className="nav-rt">
					<NavLink className="btn-font-lt nav-desktop-only nav-chat-link" to="/chats" exact={true}>
						<i className="fa-regular fa-comment"></i> Chats
						{hasUnread && <span className="nav-badge-dot" />}
					</NavLink>
					<NavLink className="btn-font-lt nav-desktop-only" to="/appointments" exact={true}>
						Appointments
					</NavLink>
					<LangToggle />
					<div
						className="photo nav-desktop-only"
						style={{ backgroundImage: `url("${image}")` }}
						onClick={openMenu}
					>
						{showMenu && (
							<div className="dropdown" ref={dropdownRef}>
								<div className="div">
									<button
										className="btn-font-lt"
										onClick={() => setShowModal(true)}
									>
										Edit my profile
									</button>
								</div>
								<div className="div">
									<LogoutButton />
								</div>
							</div>
						)}
					</div>
				</div>
				{showModal && (
					<Modal onClose={() => setShowModal(false)}>
						<UserProfile onClose={() => setShowModal(false)} />
					</Modal>
				)}
			</nav>
			{showMobileMenu && (
				<>
					<div
						className="nav-mobile-backdrop"
						onClick={() => setShowMobileMenu(false)}
					/>
					<div className="nav-mobile-menu">
						{whitelabelAgent && (
							<div className="nav-mobile-item nav-mobile-agent-header" style={{ pointerEvents: 'none', cursor: 'default' }}>
								{whitelabelAgent.photo && (
									<img
										src={whitelabelAgent.photo}
										alt={whitelabelAgent.username}
										style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', marginRight: 10 }}
									/>
								)}
								<span className="btn-font-lt">
									{whitelabelAgent.username}{whitelabelAgent.office ? `, ${whitelabelAgent.office}` : ''}
								</span>
							</div>
						)}
						<NavLink
							to="/chats"
							className="nav-mobile-item"
							onClick={() => setShowMobileMenu(false)}
						>
							<span className="nav-mobile-chat-wrap">
								<i className="fa-regular fa-comment mr-3 text-[#94a3b8]" />
								Chats
								{hasUnread && <span className="nav-badge-dot nav-badge-dot--mobile" />}
							</span>
						</NavLink>
						<NavLink
							to="/appointments"
							className="nav-mobile-item"
							onClick={() => setShowMobileMenu(false)}
						>
							<i className="fa-regular fa-calendar mr-3 text-[#94a3b8]" />
							Appointments
						</NavLink>
						<div className="nav-mobile-divider" />
						<button
							className="nav-mobile-item"
							onClick={() => {
								setShowMobileMenu(false);
								setShowModal(true);
							}}
						>
							<i className="fa-regular fa-user mr-3 text-[#94a3b8]" />
							Edit my profile
						</button>
						<button className="nav-mobile-item" onClick={onLogout}>
							<i className="fa-solid fa-right-from-bracket mr-3 text-[#94a3b8]" />
							Logout
						</button>
					</div>
				</>
			)}
		</>
	);
};
export default UserBar;
